module.exports = (parcelRequire.load("ktLr0")).then(() => parcelRequire('eN8pB'));